import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useWishlist } from "@/context/WishlistContext";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { ids } = useWishlist();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      if (ids.length === 0) { setProducts([]); setLoading(false); return; }
      try {
        const { data } = await api.get("/products");
        setProducts(data.filter((p) => ids.includes(p.id)));
      } finally { setLoading(false); }
    })();
  }, [ids]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-8 sm:py-12">
      <p className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#FF2E4C] mb-1">ΤΑ ΑΓΑΠΗΜΕΝΑ ΣΟΥ</p>
      <h1 className="font-display text-3xl sm:text-4xl font-black uppercase tracking-tighter mb-8">Wishlist</h1>
      {!loading && products.length === 0 ? (
        <div className="text-center py-24">
          <Heart className="w-16 h-16 text-zinc-700 mx-auto mb-6" />
          <p className="text-zinc-400 mb-8">Δεν έχεις αγαπημένα προϊόντα ακόμα.</p>
          <Link to="/shop" className="btn-red inline-flex px-10 py-4 text-sm font-bold tracking-widest uppercase rounded">ΑΝΑΚΑΛΥΨΕ</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6" data-testid="wishlist-grid">
          {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
        </div>
      )}
    </div>
  );
}
